export const languageValues = ['en', 'de', 'fr', 'it'] as const;
export type Language = (typeof languageValues)[number];
